import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Test sign in", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "usernameInput",
  class: "form-label"
}, "Name", -1)
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]

import { ref, computed, onMounted } from 'vue'
import { usePageTitle } from '@/util/AppUtil'
import { useIdentityApi } from '@/auth/IdentityApi'
import Spinner from '@/util/Spinner.vue'

const testDomain = "example.com"


export default /*#__PURE__*/_defineComponent({
  __name: 'TestSignInPage',
  setup(__props) {

usePageTitle("Test sign in")

const identityApi = useIdentityApi()

const username = ref('')
const password = ref('')
const busy = ref(false)

const canEdit = computed(() => !busy.value)
const canSignIn = computed(() => username.value && password.value && !busy.value)
const signInText = computed(() => busy.value ? "Signing in..." : "Sign in")

const usernameInput = ref<HTMLInputElement>()

onMounted(() => {
  setTimeout(() => {
    usernameInput.value?.focus()
    usernameInput.value?.select()
  })
})

async function signIn(e: any) { // eslint-disable-line @typescript-eslint/no-explicit-any
  e.preventDefault()
  busy.value = true

  const response = await identityApi.signInAsync(`${username.value}@${testDomain}`, password.value)
  window.location.href = "/authredirect?access_token=" + encodeURIComponent(response.access_token)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("form", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "usernameInput",
          ref_key: "usernameInput",
          ref: usernameInput,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
          required: "",
          disabled: !canEdit.value
        }, null, 8, _hoisted_4), [
          [_vModelText, username.value]
        ]),
        _createElementVNode("span", { class: "text-secondary" }, " @" + _toDisplayString(testDomain))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "password",
          id: "passwordInput",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
          required: "",
          disabled: !canEdit.value
        }, null, 8, _hoisted_6), [
          [_vModelText, password.value]
        ])
      ]),
      _createElementVNode("button", {
        type: "submit",
        class: "btn btn-primary",
        disabled: !canSignIn.value,
        onClick: signIn
      }, [
        (busy.value)
          ? (_openBlock(), _createBlock(Spinner, { key: 0 }))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(signInText.value), 1)
      ], 8, _hoisted_7)
    ])
  ]))
}
}

})